// delete chat direct messages
export const DELETE_CHAT_DIRECT_MESSAGES = 'DeleteChatDirectMessages';
export const DELETE_CHAT_DIRECT_MESSAGES_SUCCESS =
  'DeleteChatDirectMessagesSuccess';
export const DELETE_CHAT_DIRECT_MESSAGES_ERROR =
  'DeleteChatDirectMessagesError';
